import { dataMediumSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMediumSquare = /*#__PURE__*/createIcon(dataMediumSquare)
export default IconMediumSquare
